import { createAction, props } from '@ngrx/store';
import { Tenant } from '../models/tenant.models';

export const tenantChanged = createAction('[Tenant] tenantChanged', props<{ tenantId: string }>());
export const tenantsRequested = createAction('[Tenant] tenantsRequested');
export const tenantsRequestedSuccess = createAction('[Tenant] tenantsRequestedSuccess', props<{ tenants: Tenant[] }>());
export const globalTenantActivated = createAction('[Tenant] globalTenantActivated');
export const globalTenantDeactivated = createAction('[Tenant] globalTenantDeactivated');
